<template>
  <div class="container-fluid">
    <div class="w-100" v-if="attachPageStatus === 'ok'" :class="load===1 ? 'smoke':''">
      <section class="row gap-4">
        <article>
          <div>
            <p class="text-start fs-title fw-bold mb-0 color-dark">가입 서류 제출</p>
          </div>
          <span class="placeholder col-12 btn-primary"></span>
          <p class="fs-comment mb-0 color-dark">* 빠른 어플 사용을 위해서는 아래의 서류 제출이 필요합니다.</p>
        </article>
        <article class="d-flex flex-column gap-2">
          <div>
            <div class="row align-items-center">
              <div class="col-5">
                <label for="formFile" class="form-label fs-attach mb-0 color-dark">사업자등록증</label>
                <input class="form-control border-file"
                       type="file"
                       id="attach-1"
                       ref="business_license"
                       hidden="hidden"
                       v-on:change="onFileChange($event,'business_license')"/>
              </div>
              <div class="col-7 d-flex gap-1">
                <button class="btn btn-gray col-6 fw-bold">
                  <span v-text="hasAttachFile.business_license ? updateBtnText : addBtnText" @click="inputClick('business_license')"></span>
                </button>
                <button class="btn btn-gray col-6 fw-bold" v-if="hasAttachFile.business_license">
                  <span @click="removeAttachFile('business_license')">지우기</span>
                </button>
              </div>
            </div>
            <div class="fs-comment"
                 v-text="hasAttachFile.business_license ? onFileComment : nonFileComment"
                 :class="hasAttachFile.business_license ? 'on_file' : 'non_file'"
            ></div>
          </div>
          <div>
            <div class="row align-items-center">
              <div class="col-5">
                <label for="formFile" class="form-label fs-attach mb-0 color-dark">차량등록증</label>
                <input class="form-control border-file"
                       type="file"
                       id="attach-1"
                       ref="registration"
                       hidden="hidden"
                       v-on:change="onFileChange($event,'registration')"/>
              </div>
              <div class="col-7 d-flex gap-1">
                <button class="btn btn-gray col-6 fw-bold">
                  <span v-text="hasAttachFile.registration ? updateBtnText : addBtnText" @click="inputClick('registration')"></span>
                </button>
                <button class="btn btn-gray col-6 fw-bold" v-if="hasAttachFile.registration">
                  <span @click="removeAttachFile('registration')">지우기</span>
                </button>
              </div>
            </div>
            <div class="fs-comment"
                 v-text="hasAttachFile.registration ? onFileComment : nonFileComment"
                 :class="hasAttachFile.registration ? 'on_file' : 'non_file'"
            ></div>
          </div>
          <div>
            <div class="row align-items-center">
              <div class="col-5">
                <label for="formFile" class="form-label fs-attach mb-0 color-dark">화물운송자격증</label>
                <input class="form-control border-file"
                       type="file"
                       id="attach-1"
                       ref="freight_certificate"
                       hidden="hidden"
                       v-on:change="onFileChange($event,'freight_certificate')"/>
              </div>
              <div class="col-7 d-flex gap-1">
                <button class="btn btn-gray col-6 fw-bold">
                  <span v-text="hasAttachFile.freight_certificate ? updateBtnText : addBtnText" @click="inputClick('freight_certificate')"></span>
                </button>
                <button class="btn btn-gray col-6 fw-bold" v-if="hasAttachFile.freight_certificate">
                  <span @click="removeAttachFile('freight_certificate')">지우기</span>
                </button>
              </div>
            </div>
            <div class="fs-comment"
                 v-text="hasAttachFile.freight_certificate ? onFileComment : nonFileComment"
                 :class="hasAttachFile.freight_certificate ? 'on_file' : 'non_file'"
            ></div>
          </div>
        </article>
        <article>
          <p class="mb-1 fs-attach">산재보험 가입 여부 확인 (선택)</p>
          <ul class="list-unstyled">
            <li>
              <input type="radio" id="wci_no" name="first_transport_corp" :value="'2'" v-model="requestParam.first_transport_corp" @click="doubleClickedUnchecked">
              <label for="wci_no" class="fs-li">산재보험 미가입 근로자</label>
              <ol>
                <li>노무제공자 산재보험 적용 대상</li>
                <li>주선(운송)사에 산재보험 가입 대상 표기</li>
                <li>화물맨 산재보험 신고 대상</li>
              </ol>
            </li>
            <li>
              <input type="radio" id="wci_yes" name="first_transport_corp" :value="'4'" v-model="requestParam.first_transport_corp" @click="doubleClickedUnchecked">
              <label for="wci_yes" class="fs-li">산재보험 기존 가입 근로자(4대보험 가입자)</label>
              <ol>
                <li>노무제공자 산재보험 적용 미대상</li>
                <li>주선(운송)사에 산재보험 가입 대상 미표기</li>
                <li>화물맨 산재보험 미신고 대상</li>
              </ol>
            </li>
          </ul>
        </article>
      </section>
      <footer class="footer d-flex flex-column mt-3 d-flex gap-1">
        <button class="btn bg-dark col-12 fs-attach text-light" @click="moveHomepage">서류 제출 완료하기</button>
        <button class="btn btn-outline-primary col-12 fs-attach" @click="moveAfter">다음에 하기</button>
      </footer>
    </div>
  <!-- 오류 -->
    <div class="row" v-else>
    </div>
    <div v-if="load===1" id="load">
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>

/**
 * 간편회원가입 - 가입 완료페이지
 */
export default {
  name: "MemberPaperAttach",
  data(){
    return {
      load:0,
      requestParam:{
        freight_certificate:'', // 화물운송자격증 이미지 주소
        business_license:'',    // 사업자등록증 이미지 주소
        registration:'',        // 차량등록증 이미지 주소
        grade_code:0,
        user_seq:0,
        isEncrypted:'Y',
        pass_code:'',
        first_transport_corp: null  // 2 - 미가입 , 4 - 기존가입자
      },
      attachPageStatus:'',
      hasAttachFile:{
        freight_certificate:false, // 화물운송자격증 파일 여부
        business_license:false,    // 사업자등록증 코멘트
        registration:false,        // 차량등록증 코멘트
      },
      // fileName:{
      //   freight_certificate:'임시 파일명', // 화물운송자격증 파일 여부
      //   business_license:'임시 파일명',    // 사업자등록증 코멘트
      //   registration:'임시 파일명',        // 차량등록증 코멘트
      // },
      addBtnText: '사진 등록',
      updateBtnText: '수정',
      nonFileComment: '* [사진 등록] 버튼을 눌러 해당 서류를 제출해주세요.',
      onFileComment: '* 사진 등록이 완료되었습니다.',
      selectedFile:'',
      resizedImageUrl:''
    }
  },
  async mounted(){
    this.requestParam.grade_code = this.$store.getters.getGradeCode;
    this.requestParam.user_seq = this.$store.getters.getUserSeq;
    this.requestParam.isEncrypted = this.$store.getters.getIsEncrypted;
    this.requestParam.pass_code = this.$store.getters.getPasscode;
    // 검증하기
    await this.getMemberPaper();
  },
  methods: {
    moveAfter(){

      let isMancharo = this.$store.getters.getJoinUrl;

      let url = "https://www.2424-2424.com";
      if(isMancharo == 'mancharo') {
        url = "https://mancharo.com/";
      }
      // this.sendAttachLink()
      window.location.href = url;
    },
    async moveHomepage() {

      let attachImageCnt = 0;
      //validate
      //화물운송자격증
      if (!this.isEmpty(this.requestParam.freight_certificate)) {
        attachImageCnt++;
      }
      //차량등록증
      if (!this.isEmpty(this.requestParam.registration)) {
        attachImageCnt++;
      }
      //사업자등록증
      if (!this.isEmpty(this.requestParam.business_license)) {
        attachImageCnt++;
      }
      if (attachImageCnt === 0) {
        await this.$swal.fire('가입 서류 중 1개 이상\n사진을 첨부해주세요.');
        return;
      }
      attachImageCnt = 0;

      // 산재 보험 필수 확인
      // const transportValues = ['2','4'];
      // if(!transportValues.includes(this.requestParam.first_transport_corp)){
      //   await this.$swal.fire('산재보험 가입 여부를\n선택해주세요.');
      //   return;
      // }
      //
      //데이터 저장
      const result = await this.updateAttach();

      if (result.error) {
        await this.$swal.fire(result.message);
        return;
      }
      //페이지 이동
      this.$emit('current-page', {page: 'attach-completion'});

    },
    // 파일 변경 및 전송
    onFileChange(event, gubun) {

      const files = event.target.files;
      const fileForm = /(.*?)\.(jpg|jpeg|png|gif|bmp)$/;

      if (files.length <= 0) {
        return;
      }
      if (!files[0].name.match(fileForm)) {
        this.$swal.fire('잘못된 파일입니다.\n파일을 확인해주세요.');
        return;
      }

      //파일 업로드하기
      const file = files[0];
      this.fileUpload(file, gubun);
    },
    // 파일 전송
    async fileUpload(file, gubun) {
      this.load = 1;
      // 리사이즈
      const result = await this.resizeAndDisplayImage(file);

      //첨부파일 업로드
      let formData = new FormData();
      formData.append('file', result,'image.jpg');

      const imageUrl = await this.$http.post('/api/simplejoin/upload/paper', formData)
          .then(response => {
            if (!response.error) {
              //성공 - return image url
              this.load = 0;
              return response.data;
            } else {
              //실패
              this.load = 0;
              this.$swal.fire('이미지 등록 실패');
              return '';
            }
          }).catch(ex => {
            this.load = 0;
            this.$swal.fire('에러 : ' + ex);
            return '';
          });
      //이미지 저장이 안될 경우 돌아가기
      if (imageUrl === '') {
        this.load = 0;
        return;
      }

      // 버튼활성화 true로 하기
      this.hasAttachFile[gubun] = true;

      // 파일명 삽입
      // this.fileName[gubun] = file.name;

      this.requestParam[gubun] = imageUrl;
    },
    moveFocus(refTarget) {
      this.$refs[refTarget].focus();
    },
    isEmpty(value) {
      return value === undefined || value === null || String(value).trim() === '';
    },
    updateAttach() {
      return this.$http.post('/api/simplejoin/update', this.requestParam)
          .then(response => response.data)
          .catch(error => {
            this.$swal.fire("오류 발생 : " + error.message);
            return false;
          })
    },
    getMemberPaper() {
      //검증하기
      this.$http.post('/api/simplejoin/member', this.requestParam)
          .then(response => {
            const result = response.data;
            if (!result.error) {
              //정상 동작
              this.attachPageStatus = 'ok'
              const memberInfo = result.data;

              if (!this.isEmpty(memberInfo.business_license)) {
                //사업자 등록증 이미지 주소 가져오기
                this.hasAttachFile.business_license = true;
                this.requestParam.business_license = memberInfo.business_license;
              }
              if (!this.isEmpty(memberInfo.registration)) {
                //차량등록증 이미지 주소 가져오기
                this.hasAttachFile.registration = true;
                this.requestParam.registration = memberInfo.registration;
              }
              if (!this.isEmpty(memberInfo.freight_certificate)) {
                //화물운송자격증 이미지 주소 가져오기
                this.hasAttachFile.freight_certificate = true;
                this.requestParam.freight_certificate = memberInfo.freight_certificate;
              }
              if (!this.isEmpty(memberInfo.first_transport_corp)) {
                //산재보험 가입 여부(2,4) 가져오기
                this.requestParam.first_transport_corp = memberInfo.first_transport_corp;
              }

            } else {
              //예외 발생
              if (result.message === 'final-approval') {
                //회원 상태가 최종 승인된 상태일 경우
                this.attachPageStatus = 'final-approval'
                this.$swal.fire({
                      title: '최종 가입 승인된 상태입니다.',
                      html: '<div class="progress bg-hmm" role="progressbar" aria-label="Example 15px high" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style="height: 2px">\n' +
                          '  <div class="progress-bar bg-hmm" style="width: 100%"></div>\n' +
                          '</div>' +
                          '<div class="fs-5 mt-2">' +
                          '첨부 서류 수정을 원하실 경우<br/>' +
                          '고객센터에 문의해주세요<br/>' +
                          '<a class="tel-link" href="tel:1660-0303">1660-0303 (1번)</a>' +
                          '</div>',
                      showCancelButton: true,
                      reverseButtons: true,
                      confirmButton: 'py-1 px-4 btn btn-primary focus-no',
                      cancelButton: 'py-1 px-4 btn btn-cancel focus-no',
                      confirmButtonText: '전화 걸기',
                      cancelButtonText: '돌아가기',
                    }
                ).then((result) => {
                  if (result.isConfirmed) {
                    //전화하기
                    window.location.href = "tel:1660-0303";
                    this.moveHomepageByPath(result);
                  } else {
                    //돌아가기
                    this.moveHomepageByPath(result);
                  }
                });
              } else if (result.message === 'not-online') {
                //URL을 수정을 하거나 해당 Seq에 멤버 정보가 없는 경우
                this.attachPageStatus = 'not-online'
                this.$swal.fire({
                  title: '잘못된 접근입니다.',
                  html: '<div class="progress bg-hmm" role="progressbar" aria-label="Example 15px high" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style="height: 2px">\n' +
                      '  <div class="progress-bar bg-hmm" style="width: 100%"></div>\n' +
                      '</div>' +
                      '<div class="fs-5 mt-2">' +
                      '유선 가입하신 회원님은<br/>' +
                      '첨부 서류 수정을 원하실 경우<br/>' +
                      '고객센터에 문의해주세요<br/>' +
                      '<a class="tel-link" href="tel:1660-0303">1660-0303 (1번)</a>' +
                      '</div>'
                })
                    .then((result) => {
                      this.moveHomepageByPath(result);
                    });
              } else if (result.message === 'bad-path') {
                //그외 오류 발생
                this.attachPageStatus = 'bad-path'
                this.$swal.fire("잘못된 접근입니다.")
                    .then((result) => {
                      this.moveHomepageByPath(result);
                    });
              }
            }
          })
          .catch(
              err => {
                this.$swal.fire('에러 : ' + err)
                    .then((result) => {
                      this.moveHomepageByPath(result);
                    });
              });
    },
    inputClick(value) {
      this.$refs[value].click();
    },
    removeAttachFile(value) {
      this.requestParam[value] = '';
      this.hasAttachFile[value] = false;
    },
    doubleClickedUnchecked(event) {
      if (event.target.value == this.requestParam.first_transport_corp) {
        this.requestParam.first_transport_corp = null;
      } else {
        this.requestParam.first_transport_corp = event.target.value;
      }
    },
    moveHomepageByPath() {
      const pathUrl = this.$store.getters.getJoinUrl;
      let url = "https://www.2424-2424.com";
      if (pathUrl === 'mancharo') {
        url = "https://mancharo.com/";
      }
      window.location.href = url;
    },
    async resizeAndDisplayImage(file) {
      const maxWidth = 1680;
      const maxHeight = 1680;

      return new Promise((resolve) => {
        const img = new Image();
        const reader = new FileReader();

        reader.onload = (e) => {
          img.src = e.target.result;

          img.onload = () => {
            const width = img.width;
            const height = img.height;

            let newWidth = width;
            let newHeight = height;

            if (width > maxWidth) {
              newWidth = maxWidth;
              newHeight = (newWidth * height) / width;
            }

            if (newHeight > maxHeight) {
              newHeight = maxHeight;
              newWidth = (newHeight * width) / height;
            }

            const canvas = document.createElement("canvas");
            canvas.width = newWidth;
            canvas.height = newHeight;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, newWidth, newHeight);

            const result = canvas.toDataURL('image/jpeg', 0.8);
            resolve(this.dataURItoBlob(result));
            // resolve(result);
          };
        };

        reader.readAsDataURL(file);
      });
    },
    // Data URI를 Blob으로 변환하는 함수
    dataURItoBlob(dataURI) {

      const byteString = atob(dataURI.split(',')[1]);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: 'image/jpeg' });
    }
  }
}
</script>

<style scoped >

.on_file {
  color : #21A552;
}
.non_file {
  color : #3E529E;
}
#load {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed;
  display: block;
  opacity: 0.8;
  /*background: white;*/
  z-index: 99;
  text-align: center;
}
.spinner {
  position: absolute;
  width: 4em;
  height: 4em;
  border: 0.5em solid rgba(0, 0, 0, 0.1);
  top: 50%;
  left: 50%;
  margin-left: -2rem;
  margin-right: -2rem;
  border-left-color: #7983ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.smoke {
  opacity: 0.5;
}
.btn-gray {
  background-color: #E2E2E2;
  padding: 5px 12px;
}
.btn-gray:hover {
  background-color: #EEEEEE;
}
.placeholder {
  opacity: 1;
  min-height: 4px;
  margin-bottom: 10px;
}
.fs-attach {
  font-size: calc(1rem + 3px);
  font-weight: bold;
}
.fs-attach-l {
  font-size: calc(1rem + 2px);
}
input[type=radio] {
  --active: #275EFE;
  --active-inner: #fff;
  --focus: 2px rgba(39, 94, 254, .3);
  --border: #BBC1E1;
  --border-hover: #275EFE;
  --background: #fff;
  --disabled: #F6F8FF;
  --disabled-inner: #E1E6F9;
  -webkit-appearance: none;
  -moz-appearance: none;
  height: 21px;
  outline: none;
  display: inline-block;
  vertical-align: top;
  position: relative;
  margin: 0;
  cursor: pointer;
  border: 1px solid var(--bc, var(--border));
  background: var(--b, var(--background));
  transition: background 0.3s, border-color 0.3s, box-shadow 0.2s;
}
input[type=radio]:after {
  content: "";
  display: block;
  left: -0.75px;
  top: -0.75px;
  position: absolute;
  transition: transform var(--d-t, 0.3s) var(--d-t-e, ease), opacity var(--d-o, 0.2s);
}
input[type=radio]:checked {
  --b: var(--active);
  --bc: var(--active);
  --d-o: .3s;
  --d-t: .6s;
  --d-t-e: cubic-bezier(.2, .85, .32, 1.2);
}
input[type=radio]:disabled {
  --b: var(--disabled);
  cursor: not-allowed;
  opacity: 0.9;
}
input[type=radio]:disabled:checked {
  --b: var(--disabled-inner);
  --bc: var(--border);
}
input[type=radio]:disabled + label {
  cursor: not-allowed;
}
input[type=radio]:hover:not(:checked):not(:disabled) {
  --bc: var(--border-hover);
}
input[type=radio]:focus {
  box-shadow: 0 0 0 var(--focus);
}
input[type=radio]:not(.switch) {
  width: 21px;
}
input[type=radio]:not(.switch):after {
  opacity: var(--o, 0);
}
input[type=radio]:not(.switch):checked {
  --o: 1;
}
input[type=radio] + label {
  font-size: 1rem+1px;
  line-height: 21px;
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
  margin-left: 4px;
}
ol > li {
  opacity: 0.7;
}
ul > li {
  margin-bottom: 10px;
}

input[type=checkbox]:not(.switch) {
  border-radius: 7px;
}
input[type=checkbox]:not(.switch):after {
  width: 5px;
  height: 9px;
  border: 2px solid var(--active-inner);
  border-top: 0;
  border-left: 0;
  left: 7px;
  top: 4px;
  transform: rotate(var(--r, 20deg));
}
input[type=checkbox]:not(.switch):checked {
  --r: 43deg;
}
input[type=checkbox].switch {
  width: 38px;
  border-radius: 11px;
}
input[type=checkbox].switch:after {
  left: 2px;
  top: 2px;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  background: var(--ab, var(--border));
  transform: translateX(var(--x, 0));
}
input[type=checkbox].switch:checked {
  --ab: var(--active-inner);
  --x: 17px;
}
input[type=checkbox].switch:disabled:not(:checked):after {
  opacity: 0.6;
}
input[type=radio] {
  border-radius: 50%;
}
input[type=radio]:after {
  width: 19px;
  height: 19px;
  border-radius: 50%;
  background: var(--active-inner);
  opacity: 0;
  transform: scale(var(--s, 0.7));
}
input[type=radio]:checked {
  --s: .5;
}
.color-dark {
  color: #323232;
}
.fs-li {
  font-size: calc(1rem + 1px);
}
</style>